<template>
  <div class="homepage-config-management">
    <el-card>
      <div slot="header">
        <span>首页配置</span>
      </div>
      
      <el-form :model="form" ref="form" label-width="140px">
        <el-form-item label="Hero区背景图">
          <el-upload
            class="avatar-uploader"
            :action="uploadConfig.action"
            :headers="uploadConfig.headers"
            :show-file-list="false"
            :on-success="handleBgSuccess"
            :before-upload="beforeBgUpload">
            <img v-if="form.heroBackgroundUrl" :src="form.heroBackgroundUrl" class="bg-preview">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div class="upload-tip">建议尺寸：1920x1080像素，支持jpg、png格式，大小不超过5MB</div>
        </el-form-item>
        
        <el-form-item label="显示企业信息板块">
          <el-switch v-model="form.casesSectionEnabled"></el-switch>
        </el-form-item>
        
        <el-form-item label="选择展示企业" v-if="form.casesSectionEnabled">
          <el-select 
            v-model="form.selectedCaseIds" 
            multiple 
            placeholder="请选择企业（最多6个）"
            style="width: 100%">
            <el-option
              v-for="enterprise in enterprises"
              :key="enterprise.id"
              :label="enterprise.name"
              :value="enterprise.id"
              :disabled="form.selectedCaseIds.length >= 6 && !form.selectedCaseIds.includes(enterprise.id)">
            </el-option>
          </el-select>
          <div class="upload-tip">最多选择6个企业在首页展示</div>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" @click="submitForm" :loading="loading">保存配置</el-button>
          <el-button @click="resetForm">重置</el-button>
          <el-button type="success" @click="previewHomepage">预览首页</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'HomepageConfigManagement',
  data() {
    return {
      form: {
        id: null,
        heroBackgroundUrl: '',
        selectedCaseIds: [],
        selectedNewsIds: [],
        casesSectionEnabled: true,
        newsSectionEnabled: false
      },
      enterprises: [],
      loading: false
    }
  },
  computed: {
    uploadConfig() {
      return this.$http.getUploadConfig()
    }
  },
  mounted() {
    this.loadConfig()
    this.loadEnterprises()
  },
  methods: {
    async loadConfig() {
      try {
        const response = await this.$http.get('/config/homepage')
        if (response.success && response.data) {
          const data = response.data
          this.form = {
            id: data.id,
            heroBackgroundUrl: data.heroBackgroundUrl || '',
            selectedCaseIds: data.selectedCaseIds ? JSON.parse(data.selectedCaseIds) : [],
            selectedNewsIds: [],
            casesSectionEnabled: data.casesSectionEnabled !== false,
            newsSectionEnabled: false
          }
        }
      } catch (error) {
        this.$message.error('加载配置失败')
        console.error('加载配置失败:', error)
      }
    },
    
    async loadEnterprises() {
      try {
        const response = await this.$http.get('/enterprises')
        if (response.success && response.data) {
          this.enterprises = response.data || []
        }
      } catch (error) {
        console.error('加载企业列表失败:', error)
      }
    },
    
    
    handleBgSuccess(response) {
      if (response.success && response.data) {
        this.form.heroBackgroundUrl = response.data.fileUrl
        this.$message.success('背景图上传成功')
      } else {
        this.$message.error('背景图上传失败: ' + (response.message || '未知错误'))
      }
    },
    
    beforeBgUpload(file) {
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt5M = file.size / 1024 / 1024 < 5

      if (!isImage) {
        this.$message.error('背景图只能是 JPG 或 PNG 格式!')
      }
      if (!isLt5M) {
        this.$message.error('背景图大小不能超过 5MB!')
      }
      return isImage && isLt5M
    },
    
    async submitForm() {
      this.loading = true
      const submitData = {
        ...this.form,
        selectedCaseIds: JSON.stringify(this.form.selectedCaseIds),
        selectedNewsIds: JSON.stringify(this.form.selectedNewsIds)
      }
      
      try {
        const response = await this.$http.put('/config/homepage', submitData)
        if (response.success) {
          this.$message.success('配置保存成功')
          this.loadConfig()
        } else {
          this.$message.error('配置保存失败: ' + response.message)
        }
      } catch (error) {
        this.$message.error('配置保存失败')
        console.error('配置保存失败:', error)
      } finally {
        this.loading = false
      }
    },
    
    resetForm() {
      this.loadConfig()
    },
    
    previewHomepage() {
      window.open('/', '_blank')
    }
  }
}
</script>

<style scoped>
.homepage-config-management {
  max-width: 800px;
}

.bg-preview {
  width: 400px;
  height: 225px;
  object-fit: cover;
  display: block;
}

.upload-tip {
  font-size: 12px;
  color: #999;
  margin-top: 5px;
}

.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.avatar-uploader:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 400px;
  height: 225px;
  line-height: 225px;
  text-align: center;
  display: block;
}
</style>
